import TenantAddProfile from "../../TenantAddProfile";
import TextInput from "../../../UI/TextInput";

export default function ChangementLocataire({
  profiles,
  onSelectProfile,
  onCreateProfile,
}) {
  return (
    <>
      <TextInput
        type="date"
        name={"date_effet"}
        label={"Date d'effet de l'avenant"}
      />
      <TenantAddProfile
        profiles={profiles}
        onSelect={onSelectProfile}
        onCreate={onCreateProfile}
        label="Ajoutez les nouveaux locataires et / ou supprimez ceux qui partent"
        isMulti
      />
    </>
  );
}
